// extracted by mini-css-extract-plugin
module.exports = {"container":"ReportTableListPacingDiamond_container__2IJOM"};